export default __webpack_public_path__ + "static/media/img_10_thumb.9c23c9fc.JPG";